import * as React from 'react';
import * as _ from 'lodash';
import { css, StyleSheet } from 'aphrodite';
import { combineStyles, media, mixins } from '@blend/consumer-components';

import { AvoidWidowText } from '@blend/shared-react';
import * as SVGStyles from 'login-components/Common/svg/SVGStyles';
import * as IconButtonStyles from 'login-stylesheets/IconButton';

const styles = StyleSheet.create({
  button: combineStyles(IconButtonStyles.button, mixins.padding(0, 20, 0, 0), {
    height: 125,
    [media.mobileMedium]: {
      height: 105,
      marginBottom: 12,
      paddingRight: 12,
    },
  }),
  selectable: IconButtonStyles.selectable,
  buttonSelected: IconButtonStyles.buttonSelected,
  textWrapper: combineStyles(IconButtonStyles.textWrapper, {
    width: `calc(100% - ${SVGStyles.desktopWidth})`,
    [media.mobileMedium]: {
      marginLeft: 8,
      width: `calc(100% - ${SVGStyles.mobileWidth})`,
    },
  }),
  buttonText: IconButtonStyles.buttonText,
  buttonSubText: IconButtonStyles.buttonSubText,
});

export interface LargeIconButtonBase extends React.HTMLAttributes<HTMLButtonElement> {
  iconComponent: React.ComponentType;
  buttonId: string;
  text: string;
  subText?: string | string[];
  selected?: boolean;
  selectable?: boolean;
}

export interface LargeIconButtonConfig extends LargeIconButtonBase {
  value: any;
}

interface LargeIconButtonProps extends LargeIconButtonBase {
  onClick(Event): void;
}

export default class LargeIconButton extends React.PureComponent<LargeIconButtonProps> {
  render() {
    const { iconComponent, text, subText, selected, onClick, selectable = true, buttonId, ...buttonProps } = this.props;
    const Icon = iconComponent;
    const subTextArray = _.isArray(subText) ? subText : _.compact([subText]);

    return (
      <button
        id={buttonId}
        className={css([styles.button, selected && styles.buttonSelected, selectable && styles.selectable])}
        onClick={onClick}
        {...buttonProps}
      >
        <Icon />
        <div className={css(styles.textWrapper)}>
          <h2 className={css(styles.buttonText)}>
            <AvoidWidowText text={text} />
          </h2>
          {_.map(subTextArray, (buttonSubText, i) => (
            <p key={i} className={css(styles.buttonSubText)}>
              {buttonSubText}
            </p>
          ))}
        </div>
      </button>
    );
  }
}
